import ResultType from "./ResultType.js";

const ResultData = {
    Id: { key: 'ResultID', name: 'Result Id', type: 'NUMBER' },
    SessionId: { key: 'SessionID', name: 'Session Id', type: 'NUMBER' },
    PlayerId: { key: 'PlayerID', name: 'Player Id', type: 'NUMBER' },
    TagId: { key: 'TagID', name: 'Tag ID', type: 'NUMBER' },
    Type: { key: 'ResultType', name: 'Result Type', type: 'STRING', enum: ResultType },
    CreateDate: { key: 'CreateDate', name: 'UTC Time', type: 'STRING' },
    IsInvalid: { key: 'IsInvalid', name: 'UTC Time', type: 'BOOL' },
    PitchId: { key: 'PitchResultID', name: 'Related Pitch Id', type: 'NUMBER' },
    HitId: { key: 'HitResultID', name: 'Related Hit Id', type: 'NUMBER' },
    BatterTagId: { key: 'RelatedBatterTagID', name: 'Related Batter Tag Id', type: 'NUMBER' },
    BatterPlayerId: { key: 'RelatedBatterPlayerID', name: 'Related Batter Player Id', type: 'NUMBER' },
    AtBatIndex: { key: 'AtBatIndex', name: 'At Bat', type: 'NUMBER' },
    BatId: { key: 'BatID', name: 'Bat Id', type: 'NUMBER' },
    Data: { key: 'Data', name: 'Data', type: 'OBJECT' },
    ScoringType: { key: 'scoringType', name: 'Scoring type', type: 'STRING' },
    Media: { key: 'Media', name: 'Media', type: 'ARRAY' },

    getDataPath(parameterKey, dataSection, resultType) {
        if (resultType || dataSection) {
            return this.getNewDataPath(parameterKey, dataSection, resultType);
        }

        if (parameterKey instanceof Array) {
            return [this.Data.key].concat(parameterKey);
        }

        if (typeof(parameterKey) === 'string'){
           return [this.Data.key, parameterKey];
        }

        throw new Error("Only strings and arrays can be used as parameterKey");
    },

    mapPath(odlKey) {
        return odlKey.charAt(0).toLowerCase() + odlKey.slice(1);
    },

    getNewDataPath(parameterKey, dataSection, resultType) {
        const targetPath = [this.mapPath(this.Data.key)];

        if (dataSection) {
            targetPath.push(dataSection);
        }

        if (resultType) {
            switch (resultType) {
                case ResultType.Pitch.key:
                    targetPath.push('pitch');
                    break;

                case ResultType.Hit.key:
                    targetPath.push('hit');
                    break;
            
                default:
                    targetPath.push(resultType);
                    break;
            }
        }

        if (parameterKey instanceof Array) {
            return targetPath.concat(parameterKey);
        }

        if (typeof(parameterKey) === 'string'){
            targetPath.push(parameterKey);
            return targetPath;
        }
        
        throw new Error("Only strings and arrays can be used as parameterKey");
    },
};

export default ResultData;